import { mainSiteUrl } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Premium%20sneaker%20store%20interior%20with%20warm%20amber%20track%20lighting%2C%20rows%20of%20designer%20athletic%20shoes%20on%20floating%20white%20shelves%2C%20modern%20retail%20photography%20with%20bokeh%20background%2C%20clean%20minimalist%20architecture%2C%20warm%20golden%20tones%20with%20neutral%20white%20walls%2C%20luxury%20footwear%20boutique%20atmosphere%2C%20sharp%20product%20detail%20on%20stitching%20and%20textures&width=1800&height=900&seq=hero-bg-hipobuy-2026-v2&orientation=landscape"
          alt="Hipobuy Spreadsheet lifestyle product photography"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
            <i className="ri-sparkling-line text-accent-300 text-sm"></i>
            <span className="text-xs font-medium text-background-50">Updated for 2026</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
            Hipobuy Spreadsheet 2026:<br />
            <span className="text-accent-300">The Ultimate Resource Guide</span> For Smart Product Discovery
          </h1>

          <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            Discover organized product spreadsheets, category collections, comparison guides and safety information designed to help shoppers save time and make better decisions.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="group px-7 py-3 rounded-full text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center gap-2"
            >
              <span>Buy It Now</span>
              <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </a>

            <Link
              to="/hipobuy-spreadsheet-guide"
              className="group px-7 py-3 rounded-full text-sm font-semibold text-background-50 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm border border-background-50/30 transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center gap-2"
            >
              <span>View Spreadsheet Guides</span>
              <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
            </Link>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-8">
            <div className="flex items-center gap-1.5 text-background-50/80">
              <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
              <span className="text-xs font-medium">Updated Resources</span>
            </div>
            <div className="flex items-center gap-1.5 text-background-50/80">
              <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
              <span className="text-xs font-medium">Detailed Guides</span>
            </div>
            <div className="flex items-center gap-1.5 text-background-50/80">
              <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
              <span className="text-xs font-medium">Category Comparisons</span>
            </div>
            <div className="flex items-center gap-1.5 text-background-50/80">
              <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
              <span className="text-xs font-medium">Safety Information</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/60 text-xl"></i>
      </div>
    </section>
  );
}